import React from 'react'
import PropTypes from 'prop-types'

import { DropdownList } from 'react-widgets';

const ID_INDEX = 0;

export default class NetworkSelector extends React.Component {

  static propTypes = {
    onSelect : PropTypes.func,
    current : PropTypes.string,
    networks : PropTypes.object
  }
  
  constructor( props ) {
    super( props );
    this.onSelect = this.onSelect.bind( this );
  }

  onSelect( value ) {
    if ( this.props.onSelect ) {
      this.props.onSelect( value.network );
    }
  }

  render() {
    const { networks, current, onSelect } = this.props
    let shared = ( networks && networks.shared ) || []
    let project = ( networks && networks.project ) || []

    shared = ( [].concat( shared ) ).sort( sort )
    project = ( [].concat( project ) ).sort( sort )

    const values = [ { name : 'No Network', value : '//None//', group : 'Shared Networks' } ]
    const options = []
    if ( shared ) {
      shared.forEach( ( network ) => {
        if ( network.simulation !== true ) {
          values.push( { group : 'Shared Networks', name : network.name, value : network.id, network } )
        }
      } )
    }
    if ( project ) {
      project.forEach( ( network ) => {
        values.push( { group : 'Project Networks', name : network.name, value : network.id, network } )
      } )
    }
            
    return (
      <DropdownList
        valueField="value"
        textField="name"
        data={values}
        value={current}
        placeholder="No Network"
        groupBy="group"
        onChange={this.onSelect} />
    )
  }

}

function sort( a, b ) {
  return a.name > b.name
}
